module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-fec2f6aca6fa09ba1cfddd653e5b835b.png";